import * as types from "../mutation-types"
import * as invoiceConfig from "../../constants/invoice"
import * as invoiceApi from "../../api/invoice"

const state = {
  invoiceTotalOriginPrice: 0, //发票总金额
  invoiceTotalPrice: 0, //发票总金额
  invoiceTitleItems: {
    //发票抬头的数据
    1: {},
    2: {},
    3: {},
    4: {},
    "4-1": {}
  },
  // invoiceTitleItems: {},
  invoiceItemsErrorTip: {},
  invoiceType: 0, //发票类型：个人||组织||公司
  invoiceFormType: invoiceConfig.invoiceType.ELECTRONIC, //发票类型：电子||纸质
  currentInvoiceTitleTab: 0, //当前发票抬头的tab
  enableCommit: true, //是否可以提交
  selectedInvoice: [], //已选中的发票
  selectedInvoiceCftIds: [], //已选中发票的渠道订单id
  currentInvoiceInfo: {}, //当前发票信息，查看电子发票使用
  selectInvoiceClassification: [], // 已选择发票分主体
  deleteInvoiceClassification: [] // 提交失败的发票分类，提示时展示
}

const getters = {
  invoiceTotalOriginPrice: state => state.invoiceTotalOriginPrice,
  invoiceTotalPrice: state => state.invoiceTotalPrice,
  invoiceTitleItems: state => state.invoiceTitleItems,
  invoiceItemsErrorTip: state => state.invoiceItemsErrorTip,
  currentInvoiceTitleTab: state => state.currentInvoiceTitleTab,
  invoiceType: state => state.invoiceType,
  invoiceFormType: (state, getters) => {
    if (getters.isSpecial) {
      return invoiceConfig.invoiceType.PAPER
    }
    return invoiceConfig.invoiceType.ELECTRONIC
  },
  enableCommit: state => state.enableCommit,
  selectedInvoice: state => state.selectedInvoice,
  selectedInvoiceCftIds: state => state.selectedInvoiceCftIds,
  currentInvoiceInfo: state => state.currentInvoiceInfo,
  selectInvoiceClassification: state => state.selectInvoiceClassification,
  deleteInvoiceClassification: state => state.deleteInvoiceClassification
}

const actions = {
  setInvoiceTotalOriginPrice({ commit }, invoiceTotalOriginPrice) {
    commit(types.SET_INVOICE_TOTAL_ORIGIN_PRICE, invoiceTotalOriginPrice)
  },
  setInvoiceTotalPrice({ commit }, invoiceTotalPrice) {
    commit(types.SET_INVOICE_TOTAL_PRICE, invoiceTotalPrice)
  },
  setInvoiceTitleItems({ commit }, { tab, data }) {
    commit(types.SET_INVOICE_TITLE_ITEMS, { tab, data })
  },
  setInvoiceItemsErrorTip({ commit }, errTip) {
    commit(types.SET_INVOICE_ITEMS_ERRTIP, errTip)
  },
  setCurrentInvoiceTitleTab({ commit }, currentInvoiceTitleTab) {
    commit(types.SET_INVOICE_TAB, currentInvoiceTitleTab)
  },
  setInvoiceType({ commit }, invoiceType) {
    commit(types.SET_INVOICE_TYPE, invoiceType)
  },
  setInvoiceFormType({ commit }, invoiceFormType) {
    commit(types.SET_INVOICE_FORM_TYPE, invoiceFormType)
  },
  setInvoiceEnableCommit({ commit }, enableCommit) {
    commit(types.SET_ENABLE_COMMIT, enableCommit)
  },
  setSelectedInvoice({ commit, dispatch }, selectedInvoice) {
    dispatch("setSelectInvoiceClassification", selectedInvoice)
    commit(types.SET_SELECTED_INVOICE, selectedInvoice)
  },
  setSelectedInvoiceCftIds({ commit }, selectedInvoiceCftIds) {
    commit(types.SET_SELECTED_INVOICE_CFTIDS, selectedInvoiceCftIds)
  },
  setCurrentInvoiceInfo({ commit }, currentInvoiceInfo) {
    commit(types.SET_CURRENT_INVOICE_INFO, currentInvoiceInfo)
  },
  // 选中的发票按主体划分
  setSelectInvoiceClassification({ commit }, selectedInvoice) {
    let classificationList = invoiceApi.classify(selectedInvoice)
    let newSelectInvoiceClassification = invoiceApi.handleClassificationListInfo(classificationList)
    commit(types.SET_SELECTED_CLASSIFICATION, newSelectInvoiceClassification)
  },
  // 开票失败的发票重新按主体划分
  setDeleteInvoiceClassification({ getters, commit, dispatch }, failedInvoiceList) {
    let classificationList = invoiceApi.classify(failedInvoiceList)
    let newSelectInvoiceClassification = invoiceApi.handleClassificationListInfo(
      classificationList,
      getters.selectInvoiceClassification
    )
    commit(types.SET_DEL_SELECTED_CLASSIFICATION, newSelectInvoiceClassification)
  }
}

const mutations = {
  [types.SET_INVOICE_TOTAL_ORIGIN_PRICE](state, invoiceTotalOriginPrice) {
    state.invoiceTotalOriginPrice = invoiceTotalOriginPrice
  },
  [types.SET_INVOICE_TOTAL_PRICE](state, invoiceTotalPrice) {
    state.invoiceTotalPrice = invoiceTotalPrice
  },
  [types.SET_INVOICE_TITLE_ITEMS](state, { tab, data }) {
    state.invoiceTitleItems[tab] = data
  },
  [types.SET_INVOICE_ITEMS_ERRTIP](state, errTip) {
    state.invoiceItemsErrorTip = errTip
  },
  [types.SET_INVOICE_TYPE](state, invoiceType) {
    state.invoiceType = invoiceType
  },
  [types.SET_INVOICE_FORM_TYPE](state, invoiceFormType) {
    state.invoiceFormType = invoiceFormType
  },
  [types.SET_INVOICE_TAB](state, currentInvoiceTitleTab) {
    state.currentInvoiceTitleTab = currentInvoiceTitleTab
  },
  [types.SET_ENABLE_COMMIT](state, enableCommit) {
    state.enableCommit = enableCommit
  },
  [types.SET_SELECTED_INVOICE](state, selectedInvoice) {
    state.selectedInvoice = selectedInvoice
  },
  [types.SET_SELECTED_INVOICE_CFTIDS](state, selectedInvoiceCftIds) {
    state.selectedInvoiceCftIds = selectedInvoiceCftIds
  },
  [types.SET_CURRENT_INVOICE_INFO](state, currentInvoiceInfo) {
    state.currentInvoiceInfo = currentInvoiceInfo
  },
  [types.SET_SELECTED_CLASSIFICATION](state, selectInvoiceClassification) {
    state.selectInvoiceClassification = selectInvoiceClassification
  },
  [types.SET_DEL_SELECTED_CLASSIFICATION](state, deleteInvoiceClassification) {
    state.deleteInvoiceClassification = deleteInvoiceClassification
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
